import cn from "classnames"
import React from "react"
import { useTranslation } from "react-i18next"
import MerchantDashboardCellContainer from "../MerchantDashboardCellContainer"
import MerchantDashboardTileHeader from "./MerchantDashboardTileHeader"
import "./MerchantDashboardTileNoData.scss"

interface IMerchantDashboardTileNoDataProps {
    title: string
    icon?: string
    subtitle: string
    hintIconText?: string
    noDataText?: string
    isSwiipePaymentsNotEnabled?: boolean
    children?: React.ReactNode
}

const MerchantDashboardTileNoData = ({
    title,
    icon,
    subtitle,
    hintIconText,
    noDataText,
    isSwiipePaymentsNotEnabled,
    children,
}: IMerchantDashboardTileNoDataProps) => {
    const { t } = useTranslation()
    return (
        <MerchantDashboardCellContainer className="merchant-dashboard-tile-no-data">
            <MerchantDashboardTileHeader
                title={title}
                icon={icon}
                subtitle={subtitle}
                hintIconText={hintIconText}
                isDisabled={!children}
            />
            <div className={cn("no-data-text", { "text-disabled": !children })}>
                {noDataText ??
                    (isSwiipePaymentsNotEnabled
                        ? t("merchantDashboard.aeraPaymentsNotEnabledError")
                        : t("merchantDashboard.noData"))}
            </div>
            {children}
        </MerchantDashboardCellContainer>
    )
}

export default MerchantDashboardTileNoData
